<template>
  <div>
    <ToggleButton
      v-model="pageDefaultValues.isPlayed"
      onIcon="pi pi-pause"
      offIcon="pi pi-play"
      class="p-button-rounded p-button-sm mx-1 p-1"
      @click="togglePlay"
    />
  </div>
</template>
<script setup>
import TogglePlayButton from "primevue/togglebutton";
import { computed, reactive, onMounted, toRefs, onBeforeUnmount } from "vue";
import { useApp } from "@/composables/app.js";
const props = defineProps({
  src: {
    type: String,
  },
});
const app = useApp();

var audio;

const defaultValues = { isPlayed: false };
const pageDefaultValues = reactive({ ...defaultValues });

function togglePlay() {
  try {
    if (props.src) {
      if (pageDefaultValues.isPlayed) {
        if (typeof audio.loop == "boolean") {
          audio.loop = false;
          audio.autoplay = true;
        }
        audio.currentTime = 0;
        var resp = audio.play();
        if (resp !== undefined) {
          resp
            .then((_) => {
              // autoplay starts!
            })
            .catch((error) => {});
        }
        Object.assign(pageDefaultValues, { isPlayed: true });
      } else {
        audio.pause();
        Object.assign(pageDefaultValues, { isPlayed: false });
      }
    }
  } catch (e) {}
}

onMounted(() => {
  let url = `http://pbx.afrifanom.com:8269/${props.src}`;
  audio = new Audio(url);
});

onBeforeUnmount(() => {
  if (audio) {
    audio.currentTime = 0;
    audio.pause();
    Object.assign(pageDefaultValues, { isPlayed: false });
  }
});
</script>
